import {deleteCookie, getCookie, hasCookie, setCookie} from '@/services/cookie/cookieService';

const TEN_YEARS_IN_SECONDS = 10 * 365 * 24 * 60 * 60;

const COOKIE_NAMES = {
    IS_AGE_CONFIRMED: 'is_age_confirmed',
    AGE_GATE_LOCKED_UNTIL: 'age_gate_locked_until',
};

const getIsAgeGateConfirmed = (): boolean => hasCookie(COOKIE_NAMES.IS_AGE_CONFIRMED);

const setIsAgeGateConfirmed = (value: boolean): void => {
    if (value) setCookie({name: COOKIE_NAMES.IS_AGE_CONFIRMED, value: 'true', maxAgeSec: TEN_YEARS_IN_SECONDS});
    else deleteCookie({name: COOKIE_NAMES.IS_AGE_CONFIRMED});
};

const getAgeGateLockedUntil = (): number | null => {
    const value = getCookie(COOKIE_NAMES.AGE_GATE_LOCKED_UNTIL);

    if (value === null) return null;

    const parsed = parseInt(value, 10);

    return isNaN(parsed) ? null : parsed;
};

const setAgeGateLockedUntil = (timestamp: number): void => {
    setCookie({name: COOKIE_NAMES.AGE_GATE_LOCKED_UNTIL, value: String(timestamp), maxAgeSec: TEN_YEARS_IN_SECONDS});
};

const removeAgeGateLockedUntil = (): void => {
    deleteCookie({name: COOKIE_NAMES.AGE_GATE_LOCKED_UNTIL});
};

export default {
    getIsAgeGateConfirmed,
    setIsAgeGateConfirmed,
    getAgeGateLockedUntil,
    setAgeGateLockedUntil,
    removeAgeGateLockedUntil,
};
